(() => {
  const STORAGE_KEY = 'arsCartUpsellDismissedV5';

  const getPopup = () => document.querySelector('[data-ars-cart-upsell-global]');

  function dismissed() {
    try { return sessionStorage.getItem(STORAGE_KEY) === '1'; }
    catch (e) { return false; }
  }

  function dismiss() {
    const popup = getPopup();
    if (popup) popup.hidden = true;
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Unable to read cart.');
    return response.json();
  }

  function updateSubmitState() {
    const popup = getPopup();
    if (!popup) return;
    const submit = popup.querySelector('[data-ars-upsell-submit]');
    const selected = popup.querySelectorAll('[data-ars-upsell-select]:checked');
    if (submit) submit.disabled = selected.length === 0;
  }

  async function preparePopup() {
    const popup = getPopup();
    if (!popup || dismissed()) return false;

    const cart = await getCart();
    if (!cart || !cart.item_count) return false;

    const bouquetHandles = (popup.dataset.bouquetHandles || '')
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);

    const cartHandles = new Set((cart.items || []).map((item) => item.handle).filter(Boolean));
    const cartVariantIds = new Set((cart.items || []).map((item) => String(item.variant_id)));
    const cartHasBouquet = bouquetHandles.some((handle) => cartHandles.has(handle));

    let visibleCount = 0;

    popup.querySelectorAll('[data-ars-upsell-item]').forEach((item) => {
      const variantId = String(item.dataset.variantId || '');
      const isVase = item.dataset.vase === 'true';
      const alreadyInCart = cartVariantIds.has(variantId);
      const shouldHide = alreadyInCart || (isVase && !cartHasBouquet);

      item.hidden = shouldHide;

      const checkbox = item.querySelector('[data-ars-upsell-select]');
      if (checkbox) checkbox.checked = false;

      if (!shouldHide) visibleCount += 1;
    });

    updateSubmitState();
    return visibleCount > 0;
  }

  async function showPopup() {
    if (dismissed()) return;
    try {
      if (await preparePopup()) {
        const popup = getPopup();
        if (popup) popup.hidden = false;
      }
    } catch (e) {
      console.error('ARS cart upsell:', e);
    }
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-ars-upsell-select]')) {
      updateSubmitState();
    }
  });

  document.addEventListener('click', async (event) => {
    const close = event.target.closest('[data-ars-upsell-close]');
    if (close) {
      event.preventDefault();
      dismiss();
      return;
    }

    const submit = event.target.closest('[data-ars-upsell-submit]');
    if (!submit) return;

    event.preventDefault();

    const popup = getPopup();
    if (!popup) return;

    const selectedIds = Array.from(
      popup.querySelectorAll('[data-ars-upsell-select]:checked')
    )
      .map((input) => Number(input.value))
      .filter(Boolean);

    if (!selectedIds.length) return;

    const status = popup.querySelector('[data-ars-upsell-status]');
    const original = submit.textContent;

    submit.disabled = true;
    submit.textContent = 'Adding…';
    if (status) status.textContent = '';

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: selectedIds.map((id) => ({ id, quantity: 1 }))
        })
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add selected items.');
      }

      dismiss();
      window.location.reload();
    } catch (error) {
      submit.disabled = false;
      submit.textContent = original;
      if (status) status.textContent = error.message || 'Please try again.';
    }
  });

  function init() {
    if (window.location.pathname === '/cart') {
      window.setTimeout(showPopup, 180);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
})();